export default class EditableLink {
    static init() {
        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;

            if (target.classList.contains('editable-link-form__control')) {
                const input = target as HTMLInputElement;
                input.select();
            }
        });
    }

};
